// Quanity +/-
class IncrementHelper {
	private input: HTMLInputElement;
	constructor(private control: HTMLElement) {
		this.input = document.getElementById(control.getAttribute('data-increment-for')) as HTMLInputElement;
	}

	init() {
		this.input.addEventListener('change', (e) => {
			this.checkDisabled();
		});

		this.control.addEventListener('click', (e) => {
			e.preventDefault();
			this.apply();
		});
	}

	getIncrementBy(): number {
		return Number.parseInt(this.control.getAttribute('data-increment-amount'));
	}

	apply() {
		if (this.input.readOnly) {
			return;
		}
		const newValue = this.getValueAfterApplied();
		this.input.value = newValue.toString();
		this.input.dispatchEvent(new Event('change', {bubbles: true}));
	}

	getValueAfterApplied(bound: boolean = true): number {
		let value = this.input.valueAsNumber;
		value += this.getIncrementBy();
		return bound ? this.bound(value) : value;
	}

	checkDisabled() {
		const incrementBy = this.getIncrementBy();
		const newValue = this.getValueAfterApplied(false);
		const newValueBound = this.bound(newValue);
		if (
			(incrementBy < 0 && this.input.min !== undefined && newValue < Number.parseInt(this.input.min))
			|| (incrementBy > 0 && this.input.max !== undefined && newValue > Number.parseInt(this.input.max))
		) {
			this.control.setAttribute('disabled', 'disabled');
		} else {
			this.control.removeAttribute('disabled');
		}
	}

	bound(value: number): number {
		const min = this.input.min == undefined ? undefined : Number.parseInt(this.input.min);
		const max = this.input.max == undefined ? undefined : Number.parseInt(this.input.max);

		if (min !== undefined && value < min) {
			value = min;
		} else if (max !== undefined && value > max) {
			value = max;
		}

		return value;
	}
}
const helpers: Array<IncrementHelper> = [];
$('.incrementControl').each((index, control) => {
	const helper = new IncrementHelper(control);
	helper.init();
	helpers.push(helper);
});
document.addEventListener('cartUpdateDone', (e) => {
	helpers.forEach(helper => {
		helper.checkDisabled();
	});
});
